export default function FAQ() {
	const faq = document.querySelector('.wondercontest-faq');
	const $ = jQuery;

	if(!faq) return;

	const faqItems = faq.querySelectorAll('.wondercontest-faq__item');

	faqItems.forEach(item => {
		const itemContent = item.querySelector('.wondercontest-faq__answer');

		item.addEventListener('click', () => {
			item.classList.toggle('active');
			$(itemContent).slideToggle(300);
		});
	});
}